import React, { useEffect, useRef, useState } from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import '../Videoplayer/Videoplayer.css';

const Videoplayer = () => {
  const videoRef = useRef(null);
  const [video, setVideo] = useState(null);

  useEffect(() => {
    axios.get("/api/videos/active")
      .then(res => {
        if (res.data.length > 0) {
          setVideo(res.data[0]);
        }
      })
      .catch(err => console.error(err));
  }, []);

  const handleFullscreen = () => {
    const videoEl = videoRef.current;

    if (!videoEl) return;

    if (videoEl.requestFullscreen) {
      videoEl.requestFullscreen();
    } else if (videoEl.webkitRequestFullscreen) {
      videoEl.webkitRequestFullscreen();
    } else if (videoEl.msRequestFullscreen) {
      videoEl.msRequestFullscreen();
    }
  };

  // ✅ ONLY FIX (no design change)
  if (!video) return null;

  return (
    <section className="school-video-section">
      <div className="container">
        <div className="video-card row align-items-center">
          <div className="col-lg-6 video-wrapper">
            <video
              ref={videoRef}
              className="school-video"
              src={`${BASE_URL}/uploads/videofilm/${video.video}`}
              autoPlay
              muted
              loop
              playsInline
            />
          </div>

          {/* Content */}
          <div className="col-lg-6 col-md-12 video-content">
            <h2 className="video-title">
              {video.title}
            </h2>
            <p className="video-desc">
              {video.description1}
            </p>
            <p className="video-desc">
              {video.description2}
            </p>
            <p className="video-email">
              Email{" "}
              <a href={`mailto:${video.email}`}>
                {video.email}
              </a>
            </p>
            <button
              className="fullscreen-btn"
              onClick={handleFullscreen}
            >
              ⛶ Fullscreen
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Videoplayer;